import styles from "./listing_upload_temp.module.css";
import {useState} from "react";
import {Button} from "antd";
import axios from "axios";
import {useAuth} from "../../context/AppAuthContext";
import {useApp} from "../../context/AppDataContext";


export default function ListingUploadTemp() {
    /***
     Listing Object
     id: string
     is_open: bool
     title: string
     description: string
     condition: string
     trade_type: string
     is_pinned: bool
     no_views: int
     image: string (base64)
     ***/
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [condition, setCondition] = useState("New");
    const [category, setCategory] = useState("");
    const [tradeType, setTradeType] = useState("Gift");
    const [images, setImages] = useState([]);
    const {setIsLoading, apiUrl, error, success} = useApp();
    const {user} = useAuth();


    function handleSubmit() {
        const listingObject = {
            category_id: category,
            condition: condition,
            description: description,
            title: title,
            trade_type: tradeType,
            listing_images: images,
        }
        // axios.defaults.baseURL = apiUrl;
        // axios.defaults.headers.common['Content-Type'] = 'application/json';
        // axios.defaults.headers.common['Accept'] = 'application/json';
        console.log('ListingObject: ', listingObject)
        const config = {
            "Content-Type": "application/json",
            headers: {Authorization: `Bearer ${user?.access_token}`},
        };
        axios.put('listing/', listingObject, config)
            .then((res) => {
                if (res.status === 201) {
                    console.log("adding listing successfully!");
                    // navigate("/login", {replace: true});
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    const fileDataURL = file => new Promise((resolve, reject) => {
        let fr = new FileReader();
        fr.onload = () => resolve(fr.result);
        fr.onerror = reject;
        fr.readAsDataURL(file)
    });

    function showResult(file) {
        fileDataURL(file)
            .then(data => {
                if (data.includes("image") && data.includes("png")) {
                    setImages((prev) => [...prev, data])
                }
            })
            .catch(err => console.log(err));
    }

    return (
        <div>
            <p>Title</p>
            <input type={"text"} onChange={(e) => setTitle(e.target.value)}></input>
            <p>Description</p>
            <input type={"text"} onChange={(e) => setDescription(e.target.value)}></input>
            <p>Condition</p>
            <select
                onChange={(e) => setCondition((prev) => e.target.value)}
            >
                <option value={"New"}>New</option>
                <option value={"Used"}>Used</option>
            </select>
            <p>Category</p>
            <input type={"text"} onChange={(e) => setCategory(e.target.value)}></input>
            <p>Trade Type</p>
            <select
                onChange={(e) => setTradeType(e.target.value)}
            >
                <option value={"Gift"}>Gift</option>
                <option value={"Swap"}>Swap</option>
            </select>
            <p></p>
            <input type="file" id="avatar" name="avatar" accept="image/png, image/jpeg"
                   onChange={(e) => showResult(e.target.files[0])}
            />
            {images.length > 0 &&
                images.map((image, index) => (<img className={styles.image} src={image} alt={index} key={index}/>))
            }
            <Button onClick={handleSubmit}>Upload</Button>
        </div>
    )
}